/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { Avatar, Dropdown } from "antd";
import { ArrowDownIcon } from "../icons.component";
import { getInitials } from "src/utils/ui.utils";
import { ItemType } from "antd/es/menu/interface";

interface SesionProps {
  heading?: string;
  extract?: string;
  avatar?: string;
  itemsDropdown?: ItemType[]
};

const SessionSelector = ({
  heading,
  extract,
  avatar,
  itemsDropdown,
}:SesionProps) => {
  return (
    <Dropdown menu={{items: itemsDropdown}}>
      <div className="app-card-selector">
        <div className="app-card-selector__avatar">

          {!avatar ? (
            <div className="app-avatar">{getInitials(heading || '')}</div>
          ) : (
            <>
              <Avatar src={avatar} size={40}>{getInitials(heading || '')}</Avatar>
            </>
          )}
        </div>
        <div className={`app-card-selector__info`}>
          <p className="app-card-selector__heading">{heading}</p>
          <p className="app-card-selector__extract">{extract}</p>
        </div>
        <div className="app-card-selector__dropdown">
          <ArrowDownIcon />
        </div>
      </div>  
    </Dropdown>
  );
};

export default SessionSelector;
